import { Controller } from "@hotwired/stimulus"

// Refreshes the QR code frame every `intervalValue` ms (default 5 minutes)
// by POSTing to the token endpoint and swapping in the new turbo-frame.
// This is a client-side fallback — Action Cable broadcasts handle the
// immediate rotation when a token is consumed.
export default class extends Controller {
  static values = {
    url: String,
    frameId: String,
    interval: { type: Number, default: 300000 }, // 5 minutes
  }

  connect() {
    if (!this.urlValue) return
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async refresh() {
    const csrfToken = document.head
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")

    let response
    try {
      response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken, Accept: "text/html" },
      })
    } catch {
      return // network error — will retry on next interval
    }

    if (!response.ok) return

    const html = await response.text()
    const doc = new DOMParser().parseFromString(html, "text/html")
    const newFrame = doc.getElementById(this.frameIdValue)
    const currentFrame = document.getElementById(this.frameIdValue)
    if (newFrame && currentFrame) currentFrame.replaceWith(newFrame)
  }
}
